import React from 'react';
import { CheckCircle2, Globe, FileCheck, Users } from 'lucide-react';
import { Card } from './ui/card';

const CustomsClearanceSection = () => {
  const benefits = [
    {
      icon: Globe,
      title: "Multiple Countries",
      description: "Custom clearance support in 185+ countries worldwide"
    },
    {
      icon: Users,
      title: "Expert Agents",
      description: "Dedicated customs agents in key international markets"
    },
    {
      icon: FileCheck,
      title: "Documentation Support",
      description: "We handle all customs paperwork and declarations"
    },
    {
      icon: CheckCircle2,
      title: "Hassle-Free Process",
      description: "Smooth clearance without delays or complications"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl font-bold text-white mb-4">
            Zero Hassle in Customs Clearance
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Shippzy has its own customs clearance agents in multiple countries, ensuring your shipments clear customs quickly and efficiently
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="mb-16" data-aos="fade-up" data-aos-delay="200">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => {
              const IconComponent = benefit.icon;
              return (
                <Card 
                  key={index} 
                  className="bg-gray-800 border-gray-700 p-6 hover:bg-gray-750 transition-all duration-300 hover:-translate-y-2"
                  data-aos="fade-up"
                  data-aos-delay={300 + index * 100}
                >
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-yellow-500 rounded-full flex items-center justify-center">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                    <h3 className="text-lg font-semibold text-white">{benefit.title}</h3>
                    <p className="text-gray-400 text-sm">{benefit.description}</p>
                  </div>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Our experienced customs agents work directly with authorities to ensure compliance and minimize delays
          </p>
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-yellow-500 text-white px-6 py-3 rounded-full">
            <CheckCircle2 className="w-5 h-5" />
            <span className="font-semibold">Trusted by 10,000+ International Shippers</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomsClearanceSection;